// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from 'react';
import { useConfig } from '../../contexts/ConfigContext';
import styles from './landing.module.scss';

interface LandingPageProps {
  onLogin: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onLogin }) => {
  const { config, logo } = useConfig();
  return (
    <div className={styles.loginSplit}>
      <div className={styles.loginBrandPanel}>
        <div className={styles.lbpLogo}>
          <img src={logo as string} alt={`${config?.companyName || 'G42'} Logo`} width={40} height={40} />
          <span className={styles.lbpName}>{config?.companyName || 'G42'}</span>
        </div>
        <div className={styles.lbpTag}>AI-native talent acquisition platform</div>
        <div className={styles.lbpSub}>Interviewer Host · AI Skill Assessment</div>
        <div className={styles.lbpDeco}></div>
      </div>

      <div className={styles.loginFormPanel}>
        <div className={styles.lfpBox}>
          <h1>Sign in</h1>
          <div className={styles.lfpSub}>Use your {config?.companyName || 'G42'} ID to continue</div>

          <button className={styles.cta} onClick={onLogin}>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
              <polyline points="10 17 15 12 10 7" />
              <line x1="15" y1="12" x2="3" y2="12" />
            </svg>
            Log in
          </button>

          <div className={styles.lfpFoot}>No social login — {config?.companyName || 'G42'} ID only</div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
